(function () {
    "use strict";

    angular.module("app").controller("InstallationRequestController", InstallationRequestController);

    InstallationRequestController.$inject = ["$scope", "controllerDecorator", "installationRequest", "logbook", "arrayUtilities"];
    function InstallationRequestController($scope, controllerDecorator, installationRequest, logbook, arrayUtilities) {

        const context = { RequestId: null, };
        const vm = this;
        controllerDecorator.Decorate(vm, ["comments", "dialog"]);

        vm.request = null;

        vm.States = [{ Key: '10' }, { Key: '40' }, { Key: '51' }, { Key: '60' }, { Key: '130' }, { Key: '140' }, { Key: '160' }, { Key: '170' }];

        const addEntryDialogSetting = {
            templateUrl: "@/logbook/new-entry.html",
            onEscape: true,
            scope: $scope,
            size: "medium",
            title: vm.getTranslation("Logbook_NewEntry_Title"),
            buttons: {
                ok: {
                    label: vm.getTranslation("Button_Save"),
                    className: "btn-primary",
                    callback: () => {
                        if (!$scope.newEntryForm.$valid) {
                            vm.ShowError(vm.getTranslation("Form_CannotSubmit_PleaseFixValidationErrors"));
                            return false;
                        }
                        submitEntry();
                    }
                },
                cancel: {
                    label: vm.getTranslation("Button_Cancel"),
                    callback: angular.noop
                }
            }
        };

        vm.AddLogEntry = function () {
            vm.NewEntry = {};

            vm.Dialog.Custom(addEntryDialogSetting);
        };

        vm.DeleteLogEntry = deleteEntry;

        function initialize() {
            const parsed = vm.ParsePrettyUrl();
            context.RequestId = parsed.id;

            if (!!context.RequestId)
                load();
        }

        function load() {
            installationRequest.Get(
                context.RequestId,
                r => {
                    vm.request = r.data;
                    vm.Comments.Initialize({ RequestId: context.RequestId, DossierId: null, OrganisationId: vm.request.Organisation.PublicId, ICD: vm.request.ScreeningBy });
                },
                vm.ShowError,
                () => vm.SetLoadingState(false)
            );
        }


        function submitEntry() {
            logbook.CreateEntry(
                { RequestId: vm.request.PublicId, Entry: vm.NewEntry },
                r => {
                    vm.request.LogBookEntries.push(r.data);
                    delete vm.NewEntry;
                },
                vm.ShowError
            );
        }

        function deleteEntry(entry) {

            logbook.DeleteEntry(
                entry.PublicId,
                r => {
                    if (r.data === true) {
                        // Remove item
                        arrayUtilities.RemoveItem(vm.request.LogBookEntries, entry);
                    }
                },
                vm.ShowError,
            );
        }

        initialize();
    }
})();
